import {
  fetchWrapper,
  handleResponse,
  hcUrlV3,
  buildOpts,
  transformBasketResponse,
  formatBody,
  transformMenuMealResponse,
} from 'services/RequestService/helpers';

export const getBasket = async ({ params: { basketSlug, menuSlug } }) => {
  const response = await fetchWrapper(
    hcUrlV3(`/weekly_baskets/${basketSlug}?menu_id=${menuSlug}`),
    buildOpts()
  );
  return handleResponse(response);
};

export const getBasketSummary = async ({ params: { menuSlug } }) => {
  const response = await fetchWrapper(hcUrlV3(`/weekly_basket_summaries/${menuSlug}`), buildOpts());
  return handleResponse(response);
};

export const getViewableBaskets = async () => {
  const response = await fetchWrapper(hcUrlV3('/weekly_baskets'), buildOpts());
  return handleResponse(response);
};

const editBasket = async ({ method, params }) => {
  const { basketSlug, ...restParams } = params;

  const response = await fetchWrapper(
    hcUrlV3(`/weekly_baskets/${basketSlug}`),
    buildOpts({
      method,
      body: formatBody(restParams),
    })
  );

  return handleResponse(response, transformBasketResponse);
};

export const updateBasket = ({ params }) => editBasket({ params, method: 'PATCH' });

export const getBasketMenuMeal = async ({ params: { basketSlug, mealId, menuSlug } }) => {
  const response = await fetchWrapper(
    hcUrlV3(`/weekly_baskets/${basketSlug}/meals/${mealId}?menu_id=${menuSlug}`),
    buildOpts()
  );
  return handleResponse(response, transformMenuMealResponse);
};
